module.exports = __webpack_public_path__ + "static/screenshot2-d1e4b0b39906affddded8082c0685d64.png";